import { Controller } from '@hotwired/stimulus';

// Controller to toggle form sections based on access code type
export default class extends Controller {
  connect() {
    // Only run toggle on the code_type select, not on other elements
    if (this.element.tagName === 'SELECT') {
      this.toggle();
    }
  }

  toggle() {
    const codeType = this.element.value;

    // Find sections in the document (they're outside the controller element)
    const bundleSection = document.querySelector(
      '[data-access-code-type-target="bundleSection"]'
    );
    const productSection = document.querySelector(
      '[data-access-code-type-target="productSection"]'
    );
    const discountSection = document.querySelector(
      '[data-access-code-type-target="discountSection"]'
    );
    const discountTargetSection = document.querySelector(
      '[data-access-code-type-target="discountTargetSection"]'
    );
    const discountScopeSection = document.querySelector(
      '[data-access-code-type-target="discountScopeSection"]'
    );
    const discountCheckbox = document.querySelector('#discount_on_target');

    if (bundleSection) {
      bundleSection.style.display = codeType === 'bundle_access' ? '' : 'none';
    }

    if (productSection) {
      productSection.style.display = codeType === 'product_access' ? '' : 'none';
    }

    const isDiscount =
      codeType === 'percentage_discount' || codeType === 'fixed_discount';

    if (discountSection) {
      discountSection.style.display = isDiscount ? '' : 'none';
    }

    // Handle discount target section
    if (discountTargetSection) {
      if (isDiscount && discountCheckbox && discountCheckbox.checked) {
        discountTargetSection.style.display = '';
      } else {
        discountTargetSection.style.display = 'none';
        if (discountCheckbox) {
          discountCheckbox.checked = false;
        }
      }
    }

    // Scope section: visible for discount types without a target product
    if (discountScopeSection) {
      const hasTarget = discountCheckbox && discountCheckbox.checked;
      discountScopeSection.style.display =
        isDiscount && !hasTarget ? '' : 'none';
    }
  }

  toggleDiscountTarget(event) {
    const discountTargetSection = document.querySelector(
      '[data-access-code-type-target="discountTargetSection"]'
    );
    const discountScopeSection = document.querySelector(
      '[data-access-code-type-target="discountScopeSection"]'
    );

    if (discountTargetSection) {
      discountTargetSection.style.display = event.target.checked ? '' : 'none';

      // Get all radio buttons in the target section
      const radios = discountTargetSection.querySelectorAll('input[type="radio"]');

      if (!event.target.checked) {
        // Clear target selection and disable radios when unchecking
        radios.forEach((radio) => {
          radio.checked = false;
          radio.disabled = true;
          radio.removeAttribute('name'); // Remove name so it won't be submitted
        });
      } else {
        // Enable radios when checking
        radios.forEach((radio) => {
          radio.disabled = false;
          radio.setAttribute('name', 'access_code_target'); // Restore name
        });
      }
    }

    // Scope section is the inverse of target section: visible when no target selected
    if (discountScopeSection) {
      discountScopeSection.style.display = event.target.checked ? 'none' : '';
    }
  }
}
